module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/77.2ec8d781.png";